// Per-install device identifier for anonymous onboarding tracking (the funnel
// runs pre-auth, so events are keyed to the device, not an account). Created
// once and persisted in localStorage.
import { randomUuid } from '@shared/all/helpers';

const KEY = 'factiiiInstallationId';

export const getInstallationId = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;
  let id = localStorage.getItem(KEY);
  if (!id) {
    // randomUuid, not crypto.randomUUID: the LAN dev server runs over plain HTTP,
    // an insecure context where randomUUID is undefined and this crashed sign-in.
    id = randomUuid();
    localStorage.setItem(KEY, id);
  }
  return id;
};
